import axios from "axios";
import { cropr } from "../adapter";
import sortBy from "lodash/sortBy";
import { fetchRegion } from "./weatherRegionActions";
import { jwtClient } from "./authUtils";

export const REQUEST_REGIONS = "REQUEST_REGIONS";
const requestRegions = () => {
  return {
    type: REQUEST_REGIONS,
  };
};

export const RECEIVE_REGIONS = "RECEIVE_REGIONS";
const receiveRegions = (regions) => {
  return {
    type: RECEIVE_REGIONS,
    regions,
  };
};

export const FAILED_REGIONS = "FAILED_REGIONS";
const failedRegions = () => {
  return {
    type: FAILED_REGIONS,
  };
};

export const SELECT_REGION = "SELECT_REGION";
const selectRegion = (regionId) => {
  return {
    type: SELECT_REGION,
    regionId,
  };
};

export const selectFetchRegion = (apiUrl, regionId) => {
  return (dispatch) => {
    dispatch(selectRegion(regionId));
    return dispatch(fetchRegion(apiUrl, regionId));
  };
};

export const fetchRegions = (apiUrl, lat, lon) => {
  return async (dispatch) => {
    dispatch(requestRegions());

    try {
      var distance = 20000.0;
      var fromdistance = false;
      var url = apiUrl + "/api/forecast/list/";

      if (lat && lon) {
        url += "?lat=" + lat + "&lon=" + lon;
      }

      let featuresHeader = "";
      if (!cropr.permissions.staff && cropr.features && cropr.features.weather_forecast) {
        featuresHeader = "weather_forecast=" + (cropr.features.weather_forecast || 0).toString();
      }

      const response = await jwtClient.withJWT(async (jwt) => {
        return axios.get(url, {
          headers: { Authorization: "JWT " + jwt, features: featuresHeader },
        });
      });

      let regions = response.data;

      var selectedRegion;

      regions.forEach((region) => {
        if (region.distance && region.distance < distance) {
          fromdistance = true;
          distance = region.distance;
          selectedRegion = region;
        }
        if (!fromdistance && window.localStorage.getItem("defaultWeatherRegion" + cropr.farm.id)) {
          if (
            parseInt(window.localStorage.getItem("defaultWeatherRegion" + cropr.farm.id)) ===
            region.id
          ) {
            selectedRegion = region;
          }
        }
      });

      if (!selectedRegion) {
        const sorted = sortBy(regions, "name");
        selectedRegion = sorted[0];
      }

      dispatch(selectFetchRegion(apiUrl, selectedRegion.id));
      return dispatch(receiveRegions(regions));
    } catch (err) {
      return dispatch(failedRegions());
    }
  };
};

const weatherRegionsActions = { fetchRegions, selectRegion, selectFetchRegion };

export default weatherRegionsActions;
